var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.602 6.69656L13.4581 4.8404C13.8411 4.45707 14.2958 4.15295 14.7964 3.94541C15.2969 3.73787 15.8335 3.63099 16.3753 3.63086C16.9172 3.63073 17.4538 3.73737 17.9544 3.94467C18.455 4.15198 18.9099 4.45589 19.2931 4.83904C19.6763 5.2222 19.9802 5.67709 20.1875 6.17773C20.3948 6.67838 20.5014 7.21496 20.5013 7.75682C20.5012 8.29868 20.3943 8.83521 20.1867 9.33576C19.9792 9.8363 19.6751 10.2911 19.2917 10.674L16.6401 13.3257C16.257 13.7087 15.8023 14.0126 15.3018 14.2199C14.8014 14.4272 14.265 14.5339 13.7233 14.5339C13.1816 14.5339 12.6452 14.4272 12.1447 14.2199C11.6442 14.0126 11.1895 13.7087 10.8065 13.3257",
    stroke: "#08B9C5",
    strokeWidth: 1.64575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6631 17.3041L10.807 19.1603C10.424 19.5436 9.96924 19.8477 9.46869 20.0553C8.96815 20.2628 8.43162 20.3697 7.88975 20.3698C7.34789 20.3699 6.81131 20.2633 6.31067 20.056C5.81003 19.8487 5.35513 19.5448 4.97198 19.1616C4.58882 18.7785 4.28491 18.3236 4.07761 17.8229C3.8703 17.3223 3.76367 16.7857 3.76379 16.2438C3.76392 15.702 3.87081 15.1655 4.07834 14.6649C4.28588 14.1644 4.59 13.7096 4.97334 13.3266L7.62499 10.675C8.00803 10.2919 8.46277 9.98809 8.96323 9.78079C9.4637 9.57349 10.0001 9.4668 10.5418 9.4668C11.0835 9.4668 11.6199 9.57349 12.1204 9.78079C12.6208 9.98809 13.0756 10.2919 13.4586 10.675",
    stroke: "#08B9C5",
    strokeWidth: 1.64575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.518c7942.svg";
export { ForwardRef as ReactComponent };